import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import MissionView from './pages/MissionView'; // <-- your new page

function App() {
  const [user, setUser] = useState(null);

  // A wrapper for protected routes
  const ProtectedRoute = ({ children }) => {
    if (!user) return <Navigate to="/" />; // redirect to login if not logged in
    return children;
  };

  return (
    <Routes>
      {/* Login route */}
      <Route path="/" element={<LoginPage setUser={setUser} />} />

      {/* Dashboard route */}
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute>
            <Dashboard
              token={user?.token}
              role={user?.role}
              logout={() => setUser(null)}
            />
          </ProtectedRoute>
        }
      />

      {/* Mission view route */}
      <Route
        path="/mission-view/:id"
        element={
          <ProtectedRoute>
            <MissionView token={user?.token} />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
